
<template>
  <v-app id="searchHanr">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Invoice line items</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(hanrRecord,i) in searchHanr" :key="i">
           <tr @click="$router.reload('/syst/ref/hanr/onHanr/' + hanrRecord.hanr_encrid)">
             <td>{{hanrRecord.hanr_nr}}</td>
             <td>{{hanrRecord.hanr_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchHanr: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/hanr/searchHanr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHanr"
          },
          searchHanr: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchHanr = res.data.searchHanr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
